tinymce.PluginManager.add('openAi', function (editor, url) {
    editor.ui.registry.addIcon(
        "openAi-icon",
        `<svg width="24" height="24"  fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 24" class="design-iconfont">
  <mask id="mr5fs2g2n__in6cn22t9a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="23" height="24">
    <path fill="#D9D9D9" d="M0.461548 0.923065H22.615348V23.076865H0.461548z"/>
  </mask>
  <g mask="url(#mr5fs2g2n__in6cn22t9a)">
    <path d="M7.3359 5.17437C7.64862 4.54892 8.28788 4.15384 8.98715 4.15384H9.93594C11.3083 4.15384 12.201 5.59811 11.5872 6.82562L9.23078 11.5385L7.38462 15.2308L6.46155 17.0769L6.07674 17.7699C5.84193 18.1927 6.01986 18.726 6.46155 18.9231H5.53847H2.86477C1.76064 18.9231 1.04252 17.7611 1.5363 16.7736L7.3359 5.17437Z" fill="url(#mr5fs2g2n__paint0_linear_146_8730)"/>
    <path d="M16.859 18.9231H15.9102C15.211 18.9231 14.5717 18.528 14.259 17.9025L11.5385 12.4615H15.4744C16.1737 12.4615 16.8129 12.8566 17.1257 13.482L18.5103 16.2513C19.124 17.4788 18.2314 18.9231 16.859 18.9231Z" fill="url(#mr5fs2g2n__paint1_linear_146_8730)"/>
    <path d="M8.74235 12.8214C9.05962 12.5877 9.44338 12.4615 9.83748 12.4615H12.4615H14.0769H15.4792C16.1889 12.4615 16.8357 12.8683 17.1432 13.5079L17.4641 14.1757L17.1922 13.6947C16.6615 12.7561 15.3987 12.5491 14.5962 13.2692L13.5 14.0769L11.3077 15.6923L7.41152 18.5632C7.09424 18.797 6.71048 18.9231 6.31638 18.9231H3.69232H2.79678C1.7247 18.9231 1.02804 17.7941 1.50885 16.8359L1.54707 16.7597C1.32661 17.3309 1.99473 17.8321 2.48147 17.4607L3.28846 16.8448L3.8077 16.4606L4.84616 15.6923L8.74235 12.8214Z" fill="url(#mr5fs2g2n__paint2_linear_146_8730)"/>
    <path d="M17.5845 10.6154C17.5845 9.59578 18.411 8.76923 19.4306 8.76923H20.3537C21.3733 8.76923 22.1999 9.59578 22.1999 10.6154V17.0769C22.1999 18.0965 21.3733 18.9231 20.3537 18.9231H19.8922H15.91C15.2149 18.9231 14.5787 18.5326 14.2639 17.9128L14.1325 17.6538L14.6567 17.9887C15.9236 18.7979 17.5845 17.8879 17.5845 16.3846V13.8461V10.6154Z" fill="url(#mr5fs2g2n__paint3_linear_146_8730)"/>
    <path d="M17.5844 4.15384H20.3537C21.3733 4.15384 22.1998 4.98039 22.1998 5.99999C22.1998 7.0196 21.3733 7.84615 20.3537 7.84615H19.4306C18.411 7.84615 17.5844 7.0196 17.5844 5.99999V4.15384Z" fill="#FFE2D6"/>
    <path d="M8.87803 4.15384H11.3148C12.017 4.15384 12.6584 4.55219 12.9696 5.18163L16.114 11.5399H12.187C11.4831 11.5399 10.8404 11.1396 10.53 10.5078L8.76907 6.92307L8.42292 6.23076L8.07677 5.53845L7.8745 5.16915C7.77679 4.99074 7.54034 4.94624 7.38446 5.07692C7.66732 4.51119 8.24553 4.15384 8.87803 4.15384Z" fill="url(#mr5fs2g2n__paint4_linear_146_8730)"/>
  </g>
  <defs>
    <linearGradient id="mr5fs2g2n__paint0_linear_146_8730" x1="10.1539" y1="4.15384" x2="3.69232" y2="18.9231" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FF584D"/>
      <stop offset="1" stop-color="#FFE2D6"/>
    </linearGradient>
    <linearGradient id="mr5fs2g2n__paint1_linear_146_8730" x1="13.8462" y1="12.4615" x2="17.0769" y2="18.9231" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FF584D"/>
      <stop offset="1" stop-color="#FFE2D6"/>
    </linearGradient>
    <linearGradient id="mr5fs2g2n__paint2_linear_146_8730" x1="12.4615" y1="12.4615" x2="4.15385" y2="18.9231" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFD6FE"/>
      <stop offset="1" stop-color="#B1C1FF"/>
    </linearGradient>
    <linearGradient id="mr5fs2g2n__paint3_linear_146_8730" x1="19.8462" y1="8.76923" x2="19.8921" y2="18.9231" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFD6FE"/>
      <stop offset="1" stop-color="#B1C1FF"/>
    </linearGradient>
    <linearGradient id="mr5fs2g2n__paint4_linear_146_8730" x1="10.1538" y1="4.15384" x2="13.3846" y2="11.5385" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFD6FE"/>
      <stop offset="1" stop-color="#B1C1FF"/>
    </linearGradient>
  </defs>
</svg><span>创作助手</span>
`
    );

    // 注册一个工具栏按钮名称
    editor.ui.registry.addButton('openAi', {
        icon: `openAi-icon`,
        tooltip: '插入图片',
        onAction: function () {
            window.postMessage("openAi", "*");
        }
    });

    return {
        getMetadata: function () {
            return {
                //插件名和链接会显示在“帮助”→“插件”→“已安装的插件”中
                name: "",//插件名称
                url: "", //作者网址
            };
        }
    };
});